export const GRAPHQL_URL = "https://fashion-mart-server.vercel.app/graphql";